import React, { useState } from 'react';

const ContactUs = () => {
    const [form, setForm] = useState({ name: '', email: '', message: '' });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Message submitted. We'll get back to you soon!");
        setForm({ name: '', email: '', message: '' });
    };

    return (
        <div style={{ padding: '2rem', maxWidth: '700px', margin: '0 auto', background: "#fff" }}>
            <h1>Contact Us</h1>
            <p>Have questions or need support? We’re here to help.</p>

            <form onSubmit={handleSubmit}>
                <label>Name</label>
                <input name="name" value={form.name} onChange={handleChange} required style={{ width: '100%', marginBottom: '1rem' }} />

                <label>Email</label>
                <input type="email" name="email" value={form.email} onChange={handleChange} required style={{ width: '100%', marginBottom: '1rem' }} />

                <label>Message</label>
                <textarea name="message" value={form.message} onChange={handleChange} required style={{ width: '100%', marginBottom: '1rem' }} />

                <button type="submit">Submit</button>
            </form>

            <p style={{ marginTop: '2rem' }}>
                Or email us directly at <strong>support@riyms.com</strong>
            </p>
        </div>
    );
};

export default ContactUs;
